import { render, staticRenderFns } from "./ProductSheetSpecs.vue?vue&type=template&id=bceccdea&scoped=true&lang=pug&"
import script from "./ProductSheetSpecs.vue?vue&type=script&lang=js&"
export * from "./ProductSheetSpecs.vue?vue&type=script&lang=js&"
import style0 from "./ProductSheetSpecs.vue?vue&type=style&index=0&id=bceccdea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bceccdea",
  null
  
)

export default component.exports